"use strict";

module.exports = ["Send Me A Proposal", "Not A Good Fit", "Not Sure", "Liked Lite", "Disliked Lite"];